<template>
  <div class="about">
    <h1>Impressum</h1>
    <p class="p1">
      <span class="s1">Angaben gem&auml;&szlig; &sect;5 TMG ist:</span>
    </p>
    <p class="p1">
      <span class="s1">Individuallist UG (haftungsbeschr&auml;nkt)</span>
      <br>
      <span class="s1">Mettmannerstra&szlig;e 11</span>
      <br>
      <span class="s1">40233 D&uuml;sseldorf</span>
      <br>
      <span class="s1">Deutschland</span>
    </p>
    <p class="p1">
      <span class="s1">Vertreten durch:</span>
      <br>
      <span class="s1">Gesch&auml;ftsf&uuml;hrer Arkadij Bronstein</span>
    </p>
    <p class="p1">
      <span class="s1">Kontakt:</span>
      <br>
      <span class="s1">Telefon 021197715857</span>
      <br>
      <span class="s2">E-Mail: <a href="mailto:info@individuallist.com"><span class="s3">info@individuallist.com</span></a></span>
      <br>
      <span class="s2">Internet: <a href="http://www.individuallist.com/"><span class="s3">www.individuallist.com</span></a></span>
    </p>
    <p class="p1">
      <span class="s1">Registereintrag: 10.05.2017</span>
      <br>
      <span class="s1">Eintragung im Handelsregister: 10.05.2017</span>
      <br>
      <span class="s1">Registergericht: Amtsgericht D&uuml;sseldorf</span>
      <br>
      <span class="s1">Registernummer: &nbsp;HRB 80599</span>
    </p>
    <p class="p1">
      <span class="s1">Verantwortlich f&uuml;r den Inhalt nach &sect; 55 Abs. 2 RStV:</span>
      <br>
      <span class="s1">Arkadij Bronstein</span>
      <br>
      <span class="s1">Mettmannerstra&szlig;e 11</span>
      <br>
      <span class="s1">40233 D&uuml;sseldorf</span>
      <br>
      <span class="s1">Deutschland </span>
    </p>
    <p class="p1">
      <span class="s1">Finanzamt D&uuml;sseldorf-Mitte:</span>
      <br>
      <span class="s1">Steuernummer: 133/5838/4124</span>
      <br>
      <span class="s1">Umsatzsteuer-Identifikationsnummer </span>
      <br>
      <span class="s1">nach &sect;27 a Umsatzsteuergesetz:&nbsp; DE313810367</span>
    </p>
    <p class="p1">
      <span class="s1">Online-Streitbeilegung gem&auml;&szlig; Art. 14 Abs. 1 ODR-VO: Die Europ&auml;ische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit, welche Sie unter <a
        href="http://ec.europa.eu/consumers/odr/"><span
        class="s3">http://ec.europa.eu/consumers/odr/</span></a> finden.</span>
    </p>
    <p class="p1">
      <span class="s1">Zu einer Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle sind wir nicht verpflichtet, und bieten die Teilnahme an einem solchen Verfahren auch nicht an.</span>
    </p>
    <p class="p1">
      <span class="s1">Die Individuallist UG (haftungsbeschr&auml;nkt) ist aber stets bem&uuml;ht, eventuelle Meinungsverschiedenheiten mit unseren Kunden einvernehmlich beizulegen.</span>
    </p>
  </div>
</template>

<script>
export default { name: 'About' }
</script>
